module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/to-aaa24511e1160314531ac9a771642a48.svg";